import globalAxios, { AxiosInstance } from 'axios';
export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

export class AppBaseApi {
  constructor(protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {}
}
